import Button from "@mui/material/Button";
import { useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { useContext, useEffect, useRef, useState } from "react";
import { DashboardContext } from "../../DashboardContext/DashboardContextProvider";
import { FormContext } from "./context/FormProvider";
import { getMissingValues, handleNext } from "./Helper/formbtnhelper";
import SavedIndicator from "./SavedIndicator/SavedIndicator";
import useSubmitForm from "./Slides/Hooks/setSubmitForm";
import useCreateRequest from "./Slides/Hooks/useCreateRequest";
import "./styles/formbtns.css";

const FormButtons = () => {
  const {
    slide1,
    slide2,
    slide3,
    slide4,
    slide5,
    slide6,
    slide7,
    slide8,
    slide9,
    pageNumber,
    setPageNumber,
    isLoading,
    setIsLoading,
    requestStatus,
    setActiveUserId,
    timeStamp,
    setTimeStamp,
    setOpenCheckModal,
    isReady,
    setIsReady,
    slide11,
    slideStatus,
  } = useContext(FormContext);
  const { navigate, user, clientId, projectId } = useContext(DashboardContext);
  const { enqueueSnackbar } = useSnackbar();
  const submitButtonRef = useRef(null);
  let [missingValues, setMissingValues] = useState(null);

  useEffect(() => {
    let missingValuesUpdated = getMissingValues([
      slide1,
      slide2,
      slide3,
      slide4,
      slide5,
      slide6,
      slide7,
      slide8,
      slide9,
    ]);

    setMissingValues(missingValuesUpdated);
  }, [pageNumber]);

  // | CREATE REQUEST MUTATION |
  const createForm = useCreateRequest(
    clientId,
    setPageNumber,
    user,
    setActiveUserId,
    setTimeStamp,
    setIsLoading,
    enqueueSnackbar,
  );

  const submitForm = useSubmitForm(
    clientId,
    projectId,
    isReady,
    setIsReady,
    enqueueSnackbar,
    setIsLoading,
    slide11,
    missingValues,
  );

  const queryClient = useQueryClient();

  useEffect(() => {
    if (isReady === true) {
      submitButtonRef.current.click();
      setIsReady(false);
    }
  }, [isReady]);

  // *BACK HANDLER
  const handleBack = async (e) => {
    setIsReady(false);
    setPageNumber(() => pageNumber - 1);
    navigate(`./form/${clientId}/${projectId}/${pageNumber - 1}`, {
      replace: true,
    });
  };

  // *SUBMIT HANDLER
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!projectId) {
      enqueueSnackbar("Error: Project ID not found. Please try again.", {
        variant: "error",
      });
      return;
    } else if (!isReady) {
      setOpenCheckModal(true);
    } else {
      try {
        await submitForm.mutateAsync();
      } catch (error) {
        console.log("SUBMIT ERROR: ", error);
        enqueueSnackbar("Error: There was an error submitting your form.", {
          variant: "error",
        });
      }
    }
  };

  return (
    <>
      <div className="form-btns">
        <Button
          id={
            isReady ||
            submitForm.isPending ||
            pageNumber === 0 ||
            (pageNumber === 1 && projectId !== undefined)
              ? "disabled"
              : "back-btn"
          }
          variant="contained"
          onClick={
            pageNumber === 0 || (pageNumber === 1 && projectId)
              ? () => {}
              : handleBack
          }
          disabled={
            isReady ||
            submitForm.isPending === true ||
            pageNumber === 0 ||
            (pageNumber === 1 && projectId)
              ? true
              : false
          }
        >
          Back
        </Button>
        {pageNumber === 0 || !projectId ? null : (
          <SavedIndicator
            timeStamp={timeStamp ? timeStamp : null}
            isLoading={isLoading}
          />
        )}
        {pageNumber <= 10 ? (
          <Button
            id={
              (pageNumber === 0 && !clientId) ||
              (pageNumber >= 1 && slide1.projectName === "") ||
              (pageNumber === 1 && createForm.isPending === true)
                ? "disabled"
                : "next-btn"
            }
            variant="contained"
            onClick={(e) =>
              handleNext(
                e,
                clientId,
                projectId,
                slide1,
                pageNumber,
                setPageNumber,
                pageNumber + 1,
                createForm,
                queryClient,
              )
            }
            disabled={
              (pageNumber === 0 && !clientId) ||
              (pageNumber >= 1 && slide1.projectName === "") ||
              (pageNumber === 1 && createForm.isPending === true)
            }
          >
            Next
          </Button>
        ) : (
          <Button
            id={
              requestStatus === "IP" ||
              requestStatus === "I" ||
              requestStatus === "P" ||
              requestStatus === "RV"
                ? "submit-btn"
                : "disabled"
            }
            type="submit"
            variant="contained"
            onClick={handleSubmit}
            ref={submitButtonRef}
            disabled={submitForm.isPending === true || isLoading}
          >
            Submit
          </Button>
        )}
      </div>
    </>
  );
};

export default FormButtons;
